import script from "./PowerDialerHost.vue?vue&type=script&lang=ts&setup=true"
export * from "./PowerDialerHost.vue?vue&type=script&lang=ts&setup=true"

import "./PowerDialerHost.vue?vue&type=style&index=0&id=6232974d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6232974d"]])

export default __exports__